
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/cgi",
      function () {
        return require("private-next-pages/customers/cgi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/cgi"])
      });
    }
  